/* @flow */
const prefix = str => `station/metrics/${str}`;

// Called on initialization of the display component
export const INIT = prefix('INIT');

export const FETCH = prefix('FETCH');
export const FETCH_SUCCESS = prefix('FETCH_SUCCESS');
export const FETCH_FAILURE = prefix('FETCH_FAILURE');

export const SET_DATE_OPTIONS = prefix('SET_DATE_OPTIONS');
export const FETCH_UPDATED_TIME_RANGE = prefix('FETCH_UPDATED_TIME_RANGE');



// WEBPACK FOOTER //
// ./src/app/modules/metrics/action-types.js